import { Language } from "@types";
import { Locale } from "kz-ui-sdk";

/**
 * Get valid language from locale list
 * @param locales - Locale list
 * @param requested - Requested language
 * @param defaultLanguage - Default language
 * @returns Valid language
 */
export function getValidLanguage(locales: Locale[], requested?: Language, defaultLanguage?: Language) {
  return (
    locales.find((l) => l.code === requested)?.code ||
    locales.find((l) => l.isDefault)?.code ||
    locales[0]?.code ||
    defaultLanguage
  );
}
